import { render, staticRenderFns } from "./Empowerment.vue?vue&type=template&id=6fbeeb1a"
import script from "./Empowerment.vue?vue&type=script&lang=js"
export * from "./Empowerment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports